import { ApiBaseUrl } from "../config";
import { CallbackAPIModel } from "../models/apiModels";

export async function createCallback(data: CallbackAPIModel) {
  const response = await fetch(`${ApiBaseUrl}/callback`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Create callback failed!");
  }
}
